export const numeroWhatsApp = "5554996525074";

export const catalogoProdutos = [
  // {
  //   id: 1,
  //   nome: "Espora Prata Legítima",
  //   categoria: "esporas",
  //   categoriaLabel: "Espora",
  //   descricao:
  //     "Espora artesanal em prata legítima com acabamento polido. Peça única trabalhada à mão por artesãos gaúchos tradicionais. Cada detalhe é executado com precisão, garantindo durabilidade e beleza incomparáveis. Acompanha estojo de veludo.",
  //   preco: 380.0,
  //   icone: "✦",
  //   disponivel: true,
  //   fotos: ["/imagens/espora1.jpg"],
  //   detalhes: {
  //     Material: "Prata 950",
  //     Acabamento: "Polido artesanal",
  //     Origem: "Artesanal RS",
  //     Acompanha: "Estojo de veludo",
  //   },
  // },
  // {
  //   id: 2,
  //   nome: "Espora Inox Premium",
  //   categoria: "esporas",
  //   categoriaLabel: "Espora",
  //   descricao:
  //     "Espora em aço inox com detalhes escovados. Resistência e elegância em uma peça de alto padrão. Ideal para uso diário, com durabilidade excepcional e brilho duradouro.",
  //   preco: 210.0,
  //   icone: "✦",
  //   disponivel: true,
  //   fotos: ["/imagens/espora2.jpg"],
  //   detalhes: {
  //     Material: "Aço inox 304",
  //     Acabamento: "Escovado",
  //     Origem: "Artesanal RS",
  //   },
  // },
  // {
  //   id: 3,
  //   nome: "Espora Artesanal Dourada",
  //   categoria: "esporas",
  //   categoriaLabel: "Espora",
  //   descricao:
  //     "Espora com banho em ouro 18k e detalhes entalhados à mão. Peça exclusiva com certificado de autenticidade. Uma obra de arte que une tradição gaúcha e luxo contemporâneo.",
  //   preco: 520.0,
  //   icone: "✦",
  //   disponivel: true,
  //   fotos: ["/imagens/espora3.jpg"],
  //   detalhes: {
  //     Material: "Base prata c/ banho ouro 18k",
  //     Acabamento: "Entalhado à mão",
  //     Inclui: "Certificado de autenticidade",
  //     Origem: "Artesanal RS",
  //   },
  // },
  // {
  //   id: 4,
  //   nome: "Bomba Prata Lisa",
  //   categoria: "bombas",
  //   categoriaLabel: "Bomba",
  //   descricao:
  //     "Bomba tradicional em prata com design clean e filtro de alta eficiência. Ideal para quem preza pela pureza no sabor do mate. Fácil de limpar e manter. Encaixe universal.",
  //   preco: 160.0,
  //   icone: "◈",
  //   disponivel: true,
  //   fotos: [],
  //   detalhes: {
  //     Material: "Prata 950",
  //     Filtro: "Alta eficiência",
  //     Comprimento: "22 cm",
  //     Encaixe: "Universal",
  //   },
  // },
  // {
  //   id: 5,
  //   nome: "Bomba Inox Articulada",
  //   categoria: "bombas",
  //   categoriaLabel: "Bomba",
  //   descricao:
  //     "Bomba com bico articulado em inox 316. Permite ajuste preciso de posição e fácil limpeza. Acabamento fosco premium que não acumula digitais. Ideal para quem busca praticidade.",
  //   preco: 95.0,
  //   icone: "◈",
  //   disponivel: true,
  //   fotos: [],
  //   detalhes: {
  //     Material: "Aço inox 316",
  //     Acabamento: "Fosco",
  //     Diferencial: "Bico articulado",
  //     Comprimento: "20 cm",
  //   },
  // },
  // {
  //   id: 6,
  //   nome: "Bomba Prata Trabalhada",
  //   categoria: "bombas",
  //   categoriaLabel: "Bomba",
  //   descricao:
  //     "Bomba em prata 950 com ornamentos florais entalhados à mão. Uma obra de arte funcional para o chimarrão gaúcho. Cada peça é única, com variações sutis que garantem exclusividade.",
  //   preco: 290.0,
  //   icone: "◈",
  //   disponivel: true,
  //   fotos: [],
  //   detalhes: {
  //     Material: "Prata 950",
  //     Entalhe: "Floral artesanal",
  //     Comprimento: "23 cm",
  //     Peça: "Única",
  //   },
  // },
  // {
  //   id: 7,
  //   nome: "Cuia Tradicional Grande",
  //   categoria: "cuias",
  //   categoriaLabel: "Cuia",
  //   descricao:
  //     "Cuia natural curada com aro em prata. Capacidade para um chimarrão generoso. Selecionada e preparada artesanalmente com processo tradicional de cura para garantir melhor sabor.",
  //   preco: 140.0,
  //   icone: "◉",
  //   disponivel: true,
  //   fotos: ["/imagens/cuia1.jpg"],
  //   detalhes: {
  //     Aro: "Prata 950",
  //     Capacidade: "Grande (~400ml)",
  //     Cura: "Processo tradicional",
  //     Tipo: "Natural",
  //   },
  // },
  // {
  //   id: 8,
  //   nome: "Cuia com Aro Inox",
  //   categoria: "cuias",
  //   categoriaLabel: "Cuia",
  //   descricao:
  //     "Cuia natural com aro e base em inox polido. Equilíbrio perfeito entre tradição e modernidade. Resistente e elegante, ideal para o uso cotidiano com praticidade e durabilidade.",
  //   preco: 80.0,
  //   icone: "◉",
  //   disponivel: true,
  //   fotos: ["/imagens/cuia2.jpg"],
  //   detalhes: {
  //     Aro: "Inox polido",
  //     Base: "Inox",
  //     Capacidade: "Média (~300ml)",
  //     Tipo: "Natural",
  //   },
  // },
  // {
  //   id: 9,
  //   nome: "Cuia Calabresa Premium",
  //   categoria: "cuias",
  //   categoriaLabel: "Cuia",
  //   descricao:
  //     "Cuia do tipo calabresa de seleção especial, com aro em prata trabalhada e acabamento encerado. Experiência premium para um chimarrão da mais alta qualidade. Peça selecionada individualmente.",
  //   preco: 220.0,
  //   icone: "◉",
  //   disponivel: true,
  //   fotos: ["/imagens/cuia3.jpg"],
  //   detalhes: {
  //     Tipo: "Calabresa seleção",
  //     Aro: "Prata trabalhada",
  //     Acabamento: "Encerado",
  //     Capacidade: "Grande (~450ml)",
  //   },
  // },
  // {
  //   id: 10,
  //   nome: "Cuia Calabresa Premium",
  //   categoria: "cuias",
  //   categoriaLabel: "Cuia",
  //   descricao:
  //     "Cuia do tipo calabresa de seleção especial, com aro em prata trabalhada e acabamento encerado. Experiência premium para um chimarrão da mais alta qualidade. Peça selecionada individualmente.",
  //   preco: 220.0,
  //   icone: "◉",
  //   disponivel: true,
  //   fotos: ["/imagens/cuia4.jpg"],
  //   detalhes: {
  //     Tipo: "Calabresa seleção",
  //     Aro: "Prata trabalhada",
  //     Acabamento: "Encerado",
  //     Capacidade: "Grande (~450ml)",
  //   },
  // },
  // {
  //   id: 11,
  //   nome: "Cuia Calabresa Premium",
  //   categoria: "cuias",
  //   categoriaLabel: "Cuia",
  //   descricao:
  //     "Cuia do tipo calabresa de seleção especial, com aro em prata trabalhada e acabamento encerado. Experiência premium para um chimarrão da mais alta qualidade. Peça selecionada individualmente.",
  //   preco: 220.0,
  //   icone: "◉",
  //   disponivel: true,
  //   fotos: ["/imagens/cuia5.jpg"],
  //   detalhes: {
  //     Tipo: "Calabresa seleção",
  //     Aro: "Prata trabalhada",
  //     Acabamento: "Encerado",
  //     Capacidade: "Grande (~450ml)",
  //   },
  // },
  // {
  //   id: 12,
  //   nome: "Cuia Calabresa Premium",
  //   categoria: "cuias",
  //   categoriaLabel: "Cuia",
  //   descricao:
  //     "Cuia do tipo calabresa de seleção especial, com aro em prata trabalhada e acabamento encerado. Experiência premium para um chimarrão da mais alta qualidade. Peça selecionada individualmente.",
  //   preco: 220.0,
  //   icone: "◉",
  //   disponivel: true,
  //   fotos: ["/imagens/cuia6.jpg"],
  //   detalhes: {
  //     Tipo: "Calabresa seleção",
  //     Aro: "Prata trabalhada",
  //     Acabamento: "Encerado",
  //     Capacidade: "Grande (~450ml)",
  //   },
  // },
  // {
  //   id: 13,
  //   nome: "Cuia Calabresa Premium",
  //   categoria: "cuias",
  //   categoriaLabel: "Cuia",
  //   descricao:
  //     "Cuia do tipo calabresa de seleção especial, com aro em prata trabalhada e acabamento encerado. Experiência premium para um chimarrão da mais alta qualidade. Peça selecionada individualmente.",
  //   preco: 220.0,
  //   icone: "◉",
  //   disponivel: true,
  //   fotos: ["/imagens/cuia3.jpg"],
  //   detalhes: {
  //     Tipo: "Calabresa seleção",
  //     Aro: "Prata trabalhada",
  //     Acabamento: "Encerado",
  //     Capacidade: "Grande (~450ml)",
  //   },
  // },
];